import React from 'react';
import { FormikContextType, useFormikContext } from 'formik';

import { Button, IButtonProps } from '../common/Button';

interface IFormButton<T extends Record<string, unknown>>
  extends Omit<IButtonProps, 'disabled' | 'onPress'> {
  onPress?: (formik: FormikContextType<T>) => void;
  isUseSubmitting?: boolean;
}

export function FormButton<T extends Record<string, unknown>>({
  onPress,
  isUseSubmitting = true,
  ...props
}: IFormButton<T>) {
  const formik = useFormikContext<T>();

  function onPressInner() {
    if (onPress) {
      onPress(formik);
    } else {
      formik.handleSubmit();
    }
  }

  const disabled = !(formik.isValid && formik.dirty);

  // If props.isLoading is not passed (undefined) and isUseSubmitting is true
  // then use formik.isSubmitting as loading status otherwise use props.isLoading
  const isLoading =
    typeof props.isLoading !== 'boolean' && isUseSubmitting
      ? formik.isSubmitting
      : props.isLoading;

  return (
    <Button
      {...props}
      onPress={onPressInner}
      isLoading={isLoading}
      disabled={disabled}
    />
  );
}
